import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllBrands = createAsyncThunk('search/getAllBrands', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/brands`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const createNewBrand = createAsyncThunk('vehicle/createNewBrand', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/brands`, { name: payload });

    thunkAPI.dispatch(getAllBrands());

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const deleteBrand = createAsyncThunk('vehicle/deleteBrand', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/brands/${id}`);

    thunkAPI.dispatch(getAllBrands());

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});
